/*
These functions make sure WordPress
and Foundation play nice together.
*/

document.addEventListener('DOMContentLoaded', function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    document.querySelectorAll('.accordion p:empty, .orbit p:empty').forEach(function(el) {
        el.remove();
    });

	// Adds Flex Video to YouTube and Vimeo Embeds
	document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').forEach(function(el) {
		if ( el.offsetWidth / el.offsetHeight > 1.5 ) {
            var wrapper = document.createElement('div');
            wrapper.className = 'widescreen responsive-embed';
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
		} else {
            var wrapper = document.createElement('div');
            wrapper.className = 'responsive-embed';
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
		}
	});
});
